import {
    GET_PAYMENT_REGISTER_REPORT_PROGRESS, GET_PAYMENT_REGISTER_REPORT_SUCCESS, GET_PAYMENT_REGISTER_REPORT_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    paymentRegister: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const payment_register_report_reducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PAYMENT_REGISTER_REPORT_SUCCESS:
            return { ...state, paymentRegister: action.paymentRegister, loading: false };
        case GET_PAYMENT_REGISTER_REPORT_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_PAYMENT_REGISTER_REPORT_PROGRESS:
            return { ...state, loading: true, error: false };
        case RESET_MESSAGE:
            return { ...state, message: null }; // Reset the edit message
        default:
            return state
    }
}

export default payment_register_report_reducer;